import React from "react";
import { FaWhatsapp } from "react-icons/fa";

export default function WhatsAppIcon({ size = 20, className = "" }) {
  return <FaWhatsapp size={size} className={className} aria-hidden="true" />;
}
